import { createContext, useCallback, useContext, useState } from "react";

const AuthModalContext = createContext(null);

export function AuthModalProvider({ children }) {
  const [mode, setMode] = useState(null); // null | "login" | "register"

  const openAuthModal = useCallback((initialMode = "login") => setMode(initialMode), []);
  const closeAuthModal = useCallback(() => setMode(null), []);

  return (
    <AuthModalContext.Provider value={{ mode, openAuthModal, closeAuthModal }}>
      {children}
    </AuthModalContext.Provider>
  );
}

export function useAuthModal() {
  const ctx = useContext(AuthModalContext);
  if (!ctx) throw new Error("useAuthModal must be used within AuthModalProvider");
  return ctx;
}
